@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .tabContainer {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .tabPanel {
    width: 100%;
    height: 100%;
  }

  .tablist {
    width: 100%;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .tab {
    @include typography-v2-body-sm;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: var(--background-soft);
    color: var(--text-default);
    cursor: pointer;

    svg {
      fill: var(--icon-default);
    }

    &:hover {
      background-color: var(--surface-hover);
    }

    &:focus-visible {
      background-color: var(--surface-hover);
      outline: 1px solid var(--border-focus);
    }

    &.tabActive {
      &,
      &:hover,
      &:focus-visible {
        background-color: var(--surface-default);
        color: var(--icon-primary);

        svg {
          fill: var(--icon-on-primary);
        }
      }
    }

    &.tabDisabled {
      background: var(--background-soft);
      color: var(--text-disabled);
      pointer-events: none;
    }
  }

  .truncateLabels {
    .tab:not(:first-child) {
      overflow: hidden;
    }

    .tabLabel {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .imageWrapper {
    border-radius: 50%;
    overflow: hidden;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
}
